
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class RadioButtons extends Vue {
  @Prop() selectOptions!: Array<{ value: string | number | boolean, text: string }>
  @Prop({ default: '' }) selected!: string | number | boolean
  @Prop({ default: '' }) label!: string
  @Prop() customClass!: string
  @Prop() radioColor!: string
  @Prop({ default: '' }) error!: string

  localSelected: string | number | boolean = false
  displayError = ''

  get state (): boolean | null {
    return this.displayError ? false : null
  }

  mounted () {
    this.localSelected = this.selected
    this.displayError = this.error
  }

  @Watch('error')
  onErrorChange () {
    this.displayError = this.error
  }

  @Watch('localSelected')
  onLocalSelectedChange(newValue: string | number | boolean) {
    this.$emit('update:selected', newValue)
  }

  @Watch('selected')
  onSelectedPropChange(newValue: string | number | boolean) {
    this.localSelected = newValue
  }
}
